import type { Picture as PictureType } from '@/@types/common'
import ImageIcon from '@/assets/image.svg?react'
import LightBox from '@/components/LightBox/LightBox'
import clsx from 'clsx'
import { useState, type ButtonHTMLAttributes } from 'react'
import styles from './ViewPictureText.module.css'

export interface ViewPictureTextProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	data: PictureType
}

export default function ViewPictureText({ data, className, ...props }: ViewPictureTextProps) {
	const [open, setOpen] = useState(false)

	const slides = [
		{
			src: data.picUrl,
			width: data.width,
			height: data.height,
		},
	]

	return (
		<>
			<button
				type="button"
				{...props}
				className={clsx(styles.root, className)}
				onClick={(e) => {
					e.stopPropagation()
					props.onClick?.(e)
					if (e.defaultPrevented) return

					setOpen(true)
				}}
			>
				<ImageIcon className={styles.icon} />
				<span>查看图片</span>
			</button>
			<LightBox open={open} close={() => setOpen(false)} slides={slides} />
		</>
	)
}
